module.exports = __webpack_public_path__ + "img/29.6.CODm.63bb785c.png";